"use client";

import { TypeListItemCollectionGroup } from "@contentful/types";
import { notEmpty } from "@yardzen/js-util";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@yardzen/ui/components/accordion";
import { P } from "@yardzen/ui/components/p";
import { ListItemCollection } from "./ListItemCollection";

export function ListItemCollectionGroup({
  listItemCollectionGroup,
}: {
  listItemCollectionGroup: TypeListItemCollectionGroup<"WITHOUT_UNRESOLVABLE_LINKS">;
}) {
  return (
    <div>
      {listItemCollectionGroup.fields.listItemCollections && (
        <Accordion
          type="multiple"
          defaultValue={
            listItemCollectionGroup.fields.initialDisplayState ===
            "all-collections-collapsed"
              ? []
              : listItemCollectionGroup.fields.initialDisplayState ===
                  "all-collections-expanded"
                ? listItemCollectionGroup.fields.listItemCollections &&
                  listItemCollectionGroup.fields.listItemCollections.map(
                    (listItem, i) => i + "",
                  )
                : ["0"]
          }
        >
          {listItemCollectionGroup.fields.listItemCollections
            .filter(notEmpty)
            .map((listItemCollection, i) => (
              <AccordionItem
                value={`${i}`}
                key={`listItem-${listItemCollection?.sys.id}-${i}`}
                className="border-none"
              >
                <AccordionTrigger variant="arrow" className="py-2">
                  <div className="flex items-center gap-4 text-left text-base">
                    <P noSpacing>{listItemCollection?.fields.heading}</P>
                  </div>
                </AccordionTrigger>
                <AccordionContent contentWrapperClassName="pb-0">
                  <div className="border-system-grayscale-20 border-b border-t border-dashed pl-4">
                    <ListItemCollection
                      iconSize="sm"
                      hideCollectionHeader
                      listItemCollection={listItemCollection}
                      listItemsClassName="md:mt-1 sm:grid-cols-1"
                      listItemsContainerClassName="flex flex-row items-start gap-2"
                      listItemHeadingClassName="text-sm"
                      listItemIconWrapperClassName="bg-inherit p-0"
                    />
                  </div>
                </AccordionContent>
              </AccordionItem>
            ))}
        </Accordion>
      )}
    </div>
  );
}
